import LooksOneIcon from '@mui/icons-material/LooksOne';
import LooksTwoIcon from '@mui/icons-material/LooksTwo';
import LooksThreeIcon from '@mui/icons-material/Looks3';
import Divider from '@mui/material/Divider';
//icons and divider
import Grid from '@mui/material/Grid';
//grid
import { useLocation } from 'react-router-dom';
//useLocation hook to get current location

const ProgressIndicator = () => {

    const location = useLocation();
    const currentPath = location.pathname.substring(location.pathname.lastIndexOf('/')+1);//to get only the current path till student/faculty portal
    console.log(currentPath);
    const selected = currentPath === "two"? "one" : (currentPath === "three"? "two" : "three"); //cycle down one level for displaying

    return (
        <Grid container justifyContent="center" spacing={4} >
            <Grid item lg={0} md={0} justifyContent="center">
                <LooksOneIcon color={selected==='one'?'primary':'action'} fontSize="large"/>
            </Grid>
            <Grid item lg={0} md={0} justifyContent="center">
                <LooksTwoIcon color={selected==='two'?'primary':'action'} fontSize="large"/>
            </Grid>
            <Grid item lg={0} md={0} justifyContent="center">
                <LooksThreeIcon color={selected==='three'?'primary':'action'} fontSize="large"/>
            </Grid>
            <Grid item lg={12} md={12}>
            </Grid>
        </Grid>
    )

}

export default ProgressIndicator;